<template>
  <div class="imgsetting">
    <div class="list">
      <van-cell >
        <div class="container">
          <div class="upload-button" @click="addbackground">
            <img src="/static/images/program/updata.png" alt="Upload" class="upload-icon">
          </div>
          <div class="scrollable-list">
            <div class="list-item" >
              <div class="delete-button" @click="dele()">
                <img src="/static/images/program/del.png">
              </div>
              <img v-if="pageBg!== '' ||bgImg !== ''" :src="pageBg?pageBg:bgImg"  @error="errImg($event)"  class="item-image">
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <MaterialPicker v-if="isBack" type="background" :multiple="false" @select="setBackImage" @close="close" />
  </div>

</template>

<script>
import {mapActions, mapState} from "vuex";
import MaterialPicker from "@/components/MaterialPicker.vue";
import {Toast} from "vant";

export default {
  components: {MaterialPicker},
  props: {
    pageBg: {
      type: String
    },
  },
  data(){
    return{
      isBack:false,
      bgImg:''
    }
  },
  mounted() {
    if(this.sceneList.scBackImg){
      const isHttpUrl =  this.sceneList.scBackImg.startsWith("http")
      if (isHttpUrl) {
        this.bgImg=this.sceneList.scBackImg
      }else {
        this.bgImg=this.upFileUrl + this.sceneList.scBackImg
      }

    }
  },
  computed: {
    ...mapState({
      sceneList: state => state.sceneList,
    })
  },
  methods: {
    ...mapActions(['addBackground']),
    fullscreen() {
      this.$emit('fullscreen')
    },
    addbackground() {
      if(this.bgImg !='' || this.pageBg !=''){
        Toast(this.$t('append_field.oneImage'))
        return
      }
      this.isBack = true
    },
    dele() {
      this.$emit('ondele')
      this.bgImg=''
    },
    setBackImage(data) {
      this.isBack = false
      this.addBackground(data)
      const isHttpUrl =  data.url.startsWith("http")
      if (isHttpUrl) {
        this.bgImg=data.url
      }else {
      this.bgImg=this.upFileUrl + data.url
      }
    },
    close() {
      this.isBack = false
    },
    errImg(event) {
      event.target.src = '/static/images/icon_loader_failed_braseas.png'; // 设置错误图片
    },
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

@import "@/styles/mp-sort-list.scss";


.imgsetting {
  .list {
    .van-cell ,.van-cell__value{
      display:flex ;
      align-items: center;
      justify-content: space-between;
    }
  }
  .container {
    display: flex;
    //height:60px;
    width: 100%;
  }

  .upload-button {
    position: sticky;
    left: 0;
    top: 0;
    width: 40px;
    height: 40px;
    background-color: white; /* 防止内容滚动时覆盖 */
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: 2px solid #ccc;
     border-radius: 5px; !* 圆角边框 *!*/
  }

  .upload-icon {
    width: 65px;
    height: 65px;
  }

  .scrollable-list {
    width: calc(100% - 50px);
    display: flex;
    overflow-x: auto;
    margin-left: 10px; /* 为了避免与固定的上传按钮重叠 */
  }

  .img-sort-item.sortable-chosen {
    opacity: 0.92;
  }

  .scrollable-list .sortable-ghost {
    opacity: 0.45;
  }

  .list-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 10px;
    img {
      height: 60px;
      width: 60px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      -webkit-touch-callout: none;
      user-select: none;
      pointer-events: none;
    }
  }

  .delete-button {
    align-self: flex-end;
    cursor: pointer;
    position: absolute;
    top: 2px;
    right: 2px;
    img{
      width: 20px;
      height: 20px;
    }
  }





}


</style>
